// The painting is split into this many units, one unit a hundred-millionth of
// it (goldie-cloud migration 0043, products.quantity_per_item).
export const ART_UNITS_PER_PAINTING = 100_000_000

/**
 * A holding of the painting as a person reads it: "0.33% of the painting".
 * Never a unit count and never grams (goldie-cloud services/product_kind.py
 * format_quantity; the iPhone app's fmtShareOfPainting).
 *
 * Floored to two places, so a holder is never shown more than they own; a
 * share too small to show reads "less than 0.01%", none reads "0.00%". The
 * hundredths of a percent are counted in whole numbers (units x 10,000 /
 * perItem): dividing first and scaling after floored an exact share one step
 * low (70,000 units read 0.06%).
 */
export function formatShareOfPainting(
  units: number,
  perItem: number = ART_UNITS_PER_PAINTING
): string {
  const per = perItem > 0 ? perItem : ART_UNITS_PER_PAINTING
  if (!(units > 0)) return '0.00% of the painting'
  const hundredths = Math.floor((units * 10_000) / per)
  const share =
    hundredths > 0 ? `${(hundredths / 100).toFixed(2)}%` : 'less than 0.01%'
  return `${share} of the painting`
}
